import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@material-ui/core";
import React from "react";
import { IOption } from "../../models/IOption";

interface ICheckboxOptionsProps {
  children: React.ReactNode;
  options: IOption[];
  onChange: (options: IOption[]) => void;
  className?: string;
}

const CheckboxOptions = (props: ICheckboxOptionsProps) => {
  const { children, options, onChange, className } = props;

  const handleChange = (option: IOption) => {
    const newOpts = [];
    for (let i = 0; i < options.length; i++) {
      let opt = options[i];
      if (opt.Key === option.Key) {
        opt.Selected = !opt.Selected;
      }
      newOpts.push(opt);
    }
    onChange(newOpts);
  };

  const getLabel = (opt: IOption) => {
    return opt.Price ? `${opt.Description} ($${opt.Price})` : opt.Description;
  };

  return (
    <FormControl component="fieldset" className={className}>
      <FormLabel component="legend">{children}</FormLabel>
      <FormGroup>
        {options.map(opt => {
          return (
            <FormControlLabel
              key={opt.Key}
              control={<Checkbox key={opt.Key} checked={opt.Selected} onClick={() => handleChange(opt)} value={opt.Key} />}
              label={getLabel(opt)}
            />
          );
        })}
      </FormGroup>
    </FormControl>
  );
};

export default CheckboxOptions;
